import React from "react";
import { Handle, Position } from "reactflow";
import { useTranslation } from "../i18n/useTranslation";
function ToolNode({ data, selected }) {
  const t = useTranslation();
  return (
    <div
      className={`w-[200px] rounded-lg bg-white shadow-lg overflow-hidden
        transition-all duration-200 ease-in-out
        hover:bg-gray-200  ${
        selected ? "border-solid border-2 border-indigo-500/100" : ""
      }`}
    >
      <div className="flex flex-col">
        <div className="bg-gradient-to-r from-red-600 to-red-500 px-4 py-2">
          <div className="text-white text-sm font-medium">{t('toolNode.title')}</div>
        </div>
        <div className="p-4 space-y-2">
          <div className="text-sm text-gray-700">
            <span className="font-medium">{t('name')}: </span>
            {data.tool ?? t('unnamedTool')}
          </div>
        </div>
      </div>

      <Handle
        id="a"
        type="target"
        position={Position.Left}
        className="w-3 h-3 rounded-full bg-red-500 border-2 border-white -bottom-1.5"
      />
      <Handle
        id="b"
        type="source"
        position={Position.Right}
        className="w-1 rounded-full bg-blue-500"
      />
    </div>
  );
}

export default ToolNode;
